export default __webpack_public_path__ + "images/398370439740cbb91731d877f8c096f8.svg";